/* eslint-disable no-return-assign */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, {
  useState, useEffect, useRef,
} from 'react';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { useTheme } from 'emotion-theming';
import Input from '../../../../shared/_TBComponents/Input/index';
import generateUniqueId from '../../../../shared/utils/generateUniqueId';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import { TransitionGlobal } from '../../../../shared/GlobalStyles';
import Text from '../../../../shared/components/Text/Text';

const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
`;

const ScrollContainer = styled('div')`
display: flex;
flex-direction: column;
overflow-x: scroll;

`;

const QuesitonsAndRemoveIcon = styled('div')`
  display: flex;
  width: 100%;
  gap: 16px;
  align-items: center;
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  transition: ${TransitionGlobal};
  margin-top: 8px;

  min-width: 600px;
`;

const AddQuestionButton = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed ${({ theme }) => theme.colors.hover};
  border-radius: 4px;
  min-height: 36px;
  max-height: 36px;
  margin-right: ${(props) => props.addMarginRight && props.containerWidth > 650 && '28px'};
  margin-left: ${(props) => props.addMarginRight && props.containerWidth > 650 && '26px'};
  cursor: pointer;
  margin-top: 8px;
  transition: ${TransitionGlobal};
    :hover {
      opacity: 0.7;
    }
`;

const OptionWeightAndColorWrapper = styled('div')`
 display: flex;
 gap: 16px;
 width: 100%;
 gap: 16px;
`;

const AddQuestionIconAndTextContainer = styled('div')`
  display: flex;
  gap: 4px;
  align-items: center;
`;

const ColorPickerWrapper = styled('div')`
display: flex;
flex-direction: column;
justify-content: center;
gap: 4px;
`;

const ColorPicker = styled('div')`
display: flex;
align-items: center;
justify-content: center;
min-width: 47px;
max-width: 47px;
min-height: 38px;
max-height: 38px;
border: 1px solid rgb(204, 204, 204);
border-radius: 4px;
cursor: pointer;
background-color: ${(props) => props.backgroundColor};
`;

const UpAndDownArrowContainer = styled('div')`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 5px;
transition: ${TransitionGlobal};
  :hover {
    opacity: 0.7;
  }
`;

const ColorPickerRow = styled('div')`
display: flex;
padding: 8px;
gap: 4px;
border-radius: 4px;
background-color: ${({ theme }) => theme.colors.surface};
`;

const ColorBlock = styled('div')`
min-height: 24px;
max-height: 24px;
min-width: 24px;
max-width: 24px;
background-color: ${(props) => props.backgroundColor};
cursor: pointer;
display: flex;
justify-content: center;
align-items: center;
border: ${(props) => (props.backgroundColor ? 'none' : `1px solid ${props.theme.colors.hover}`)}

`;

const MultipleChoiceQuestionsFormInputs = ({
  errors,
  touched,
  setFieldValue,
  containerWidth,
  handleBlur,
}) => {
  const tooltipRef = useRef(null);
  const { colors } = useTheme();
  const [questionCount, setQuestionCount] = useState([{
    index: 0, id: `${generateUniqueId()}-null`, choiceValue: null, choiceColor: null, choiceNumericalWeight: null, isNullValue: true, isVisible: true,
  }]);
  const [tooltipVisible, setTooltipVisible] = useState({ index: null, isVisible: false });

  const colorPickerOptions = [
    {
      /** red */
      backgroundColor: '#D16D6A',
      icon: null,
    },
    {
      /** yellow */
      backgroundColor: '#F9DA78',
      icon: null,
    },
    {
      /** green */
      backgroundColor: '#9DC384',
      icon: null,
    },
    {
      /** no color */
      backgroundColor: colors.surface,
      icon: 'opt-out',
      iconColor: colors.textSecondary,
    },
  ];

  const TooltipColorPicker = (index) => (
    <ColorPickerRow ref={tooltipRef}>
      {colorPickerOptions.map((colorOption) => (
        <ColorBlock
          backgroundColor={colorOption.backgroundColor}
          onClick={() => {
            const updatedQuestionCount = [...questionCount]; /** Make copy to avoid direct mutation */
            updatedQuestionCount[index] = {
              ...updatedQuestionCount[index],
              choiceColor: colorOption?.backgroundColor,
            };
            setQuestionCount(updatedQuestionCount);
            setTooltipVisible({ index: null, isVisible: false });
          }}
        >
          {colorOption?.icon && (
          <IcomoonReact
            iconSet={iconSet}
            size={20}
            icon='opt-out'
            color={colors.textSecondary}
          />
          )}
        </ColorBlock>
      ))}

    </ColorPickerRow>
  );

  const handleAddQuestion = () => {
    /** Add a new object with incremented index and null id */
    setQuestionCount((prev) => [
      ...prev,
      {
        index: prev.length,
        id: `${generateUniqueId()}-null`,
        choiceValue: null,
        choiceColor: null,
        choiceNumericalWeight: null,
        isNullValue: true,
        isVisible: false, /** need this to handle fade in and out */
      },
    ]);
    /** set time out waits just enough time to allow new question to be rendered
     * with visibility false, so that we can fade it in from opacity 0 to 1
     * by setting visibily to true immediately after...
     */
    setTimeout(() => {
      /** fading in last quesiton/ most recently added question */
      setQuestionCount((prev) => prev.map((q, index) => (index === prev.length - 1 ? { ...q, isVisible: true } : q)));
    }, 0);
  };

  const handleRemoveQuestion = (question) => {
    setQuestionCount((prev) => prev.map((q) => (q.id === question.id ? { ...q, isVisible: false } : q)));
    setTimeout(() => {
      const updatedQuestionCount = questionCount.filter((q) => q.id !== question.id);
      setQuestionCount(updatedQuestionCount);
      /** wait until items fades out to remove item */
    }, 300);
  };

  /** keep track of added and removed question options as the user updates, filter questions that have values then
   * map through that array of objects and just return the questionIds to be passed to the form endpoint
   */
  useEffect(() => {
    if (questionCount?.length) {
      const questionsInCountWithValues = questionCount.filter(
        (questionInCount) => questionInCount.choiceValue,
      ); /** only keep items that have a choiceValue, if it is null we want to get rid of that item */

      const choicesArrayToSendToForm = questionsInCountWithValues.map((questionWithValue, index) => {
        const choice = {
          value: questionWithValue.choiceValue,
          order: index,
        };

        if (questionWithValue.choiceColor) {
          choice.color = questionWithValue.choiceColor;
        }

        if (questionWithValue.choiceNumericalWeight) {
          choice.numericalWeight = parseInt(questionWithValue.choiceNumericalWeight, 10);
        }

        return choice;
      });
      setFieldValue('choicesArray', choicesArrayToSendToForm);
    }
  }, [questionCount]);

  const moveUp = (index) => {
    if (index === 0) return; /** can't move up if already first in array */

    setQuestionCount((prev) => prev.map((item, i) => {
      if (i === index) return prev[index - 1]; /** Swap current item with the one above it */
      if (i === index - 1) return prev[index]; /** Swap the one above with the current item */
      return item; /** return others unchanged */
    }));
  };

  const moveDown = (index) => {
    setQuestionCount((prev) => {
      if (index >= prev.length - 1) return prev; /** Can't move down if it's the last item in the array */

      return prev.map((item, i) => {
        if (i === index) return prev[index + 1]; /** Swap current item with the one below */
        if (i === index + 1) return prev[index]; /** Swap the one below with the current item */
        return item;
      });
    });
  };

  const handleClickOutside = (event) => {
    if (tooltipRef.current && !tooltipRef?.current?.contains(event.target)) {
      setTooltipVisible({ index: null, isVisible: false });
    }
  };

  useEffect(() => {
    if (tooltipVisible.isVisible) {
      document.addEventListener('click', handleClickOutside);
    } else {
      document.removeEventListener('click', handleClickOutside);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [tooltipVisible]);

  return (
    <Wrapper>
      <Text fontSize='16px' fontWeight={700}>Multiple Choice Options</Text>
      <Text fontSize='16px' color={colors.textSecondary}>Enter up to 10 options that will be available for an athlete to select.</Text>
      <ScrollContainer>
        {questionCount.map((question, index) => (
          <QuesitonsAndRemoveIcon key={question.id} isVisible={question.isVisible}>
            {questionCount?.length > 1 && (
            <UpAndDownArrowContainer style={{ marginTop: index === 0 && 28 }}>
              <IcomoonReact
                iconSet={iconSet}
                size={10}
                icon='up-arrow'
                color={colors.textSecondary}
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  moveUp(index);
                }}
              />
              <IcomoonReact
                iconSet={iconSet}
                size={10}
                icon='down-arrow'
                style={{ cursor: 'pointer' }}
                color={colors.textSecondary}
                onClick={() => {
                  moveDown(index);
                }}
              />
            </UpAndDownArrowContainer>
            )}
            <OptionWeightAndColorWrapper>
              <Input
                error={!!touched.choiceValue && !!errors.choiceValue}
                errorMsg={errors.choiceValue}
                fontSize='16px'
                fontWeight={400}
                height='38px'
                label={index === 0 && 'Options'}
                name='choiceValue'
                onChange={(event) => {
                  const { value } = event.target;
                  const updatedQuestionCount = [...questionCount]; /** Make copy to avoid direct mutation */
                  updatedQuestionCount[index] = {
                    ...updatedQuestionCount[index],
                    choiceValue: value || null, /** Update the value of the current object */
                    isNullValue: !value, /** if there is not a value then set isNullValue to true, if there is a value set it to false */
                  };
                  setQuestionCount(updatedQuestionCount);
                }}
                onBlur={handleBlur}
                right='5px'
                styledPropsLabel={{
                  fontSize: '16px',
                  fontWeight: 700,
                }}
                top='38px'
                width='100%'
                placeholder={containerWidth < 308 ? 'Enter Option' : 'Enter multiple choice option'}
              />
              <Input
                type='number'
                fontSize='16px'
                fontWeight={400}
                height='38px'
                label={index === 0 && 'Weight'}
                name='choiceNumericalWeight'
                onChange={(event) => {
                  const { value } = event.target;
                  const updatedQuestionCount = [...questionCount];
                  updatedQuestionCount[index] = {
                    ...updatedQuestionCount[index],
                    choiceNumericalWeight: value || null,
                  };
                  setQuestionCount(updatedQuestionCount);
                }}
                onBlur={handleBlur}
                right='5px'
                styledPropsLabel={{
                  fontSize: '16px',
                  fontWeight: 700,
                }}
                styledPropsWrapper={{
                  flex: 1,
                  width: 124,
                }}
                top='38px'
                placeholder='i.e. 1'
              />
              <ColorPickerWrapper>
                {index === 0 && (
                <Text fontWeight={700} fontSize='16px'>Color</Text>
                )}
                <ColorPicker
                  backgroundColor={questionCount[index].choiceColor}
                  onClick={() => {
                    if (!tooltipVisible.isVisible) {
                      setTooltipVisible({ index, isVisible: true });
                    }
                  }}
                  data-tooltip-id={`color-picker-${index}`}
                >
                  {(questionCount[index].choiceColor === 'white' || !questionCount[index].choiceColor) && (
                  <IcomoonReact
                    iconSet={iconSet}
                    size={20}
                    icon='opt-out'
                    color={colors.textSecondary}
                  />
                  )}
                </ColorPicker>
                {tooltipVisible?.index === index && tooltipVisible?.isVisible && (
                <ReactTooltip
                  clickable
                  isOpen
                  opacity={1}
                  id={`color-picker-${index}`}
                  place='top'
                  content={TooltipColorPicker(index)}
                  style={{
                    backgroundColor: colors.surface,
                    opacity: 1,
                    padding: 0,
                    boxShadow: '0px 0px 1px 0px #3031330D, 0px 4px 8px 0px #3031331A',
                    fontFamily: 'Nunito Sans',
                    fontSize: '13px',
                  }}
                />
                )}
              </ColorPickerWrapper>
            </OptionWeightAndColorWrapper>
            {questionCount.length > 1 && (
            <IcomoonReact
              iconSet={iconSet}
              size={13}
              icon='remove'
              color={colors.textSecondary}
              style={{ cursor: 'pointer', marginTop: index === 0 && 24 }}
              onClick={() => {
              /** Remove by matching the id */
                handleRemoveQuestion(question);
              }}
            />
            )}
          </QuesitonsAndRemoveIcon>
        ))}
        {!!touched.choicesArray && !!errors.choicesArray && (
        <Text color='#CC0404' fontSize='13px' fontWeight={700} style={{ marginTop: '5px', marginLeft: questionCount?.length > 1 && 27 }}>{errors?.choicesArray}</Text>
        )}
      </ScrollContainer>
      {questionCount?.length < 10 && (
      <AddQuestionButton onClick={() => handleAddQuestion()} containerWidth={containerWidth} addMarginRight={questionCount?.length > 1}>
        <AddQuestionIconAndTextContainer>
          <IcomoonReact
            iconSet={iconSet}
            size={10}
            icon='plus'
            color='#5F8BDC'
          />
          <Text fontSize='16px' color='#5F8BDC'>Add Option</Text>
        </AddQuestionIconAndTextContainer>
      </AddQuestionButton>
      )}
    </Wrapper>
  );
};

export default MultipleChoiceQuestionsFormInputs;
